module.exports = __webpack_public_path__ + "static/img/lamps-left.6ec91ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lamps-left.png
// module id = 339
// module chunks = 1